export default "__VITE_ASSET__f6bca42f__"